const appVersion = "2026.2.20";
export default appVersion;
//please do not edit the lines above